import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "imgBuffer",
})
export class ImgBufferPipe implements PipeTransform {
  public transform(value: string): string {
    if (value) {
      return "data:image/jpg;base64," + value;
    } else return "";
  }
}
